// RESUME SEARCH ALERT - DELETE **************************************************************************
// pathname: /v1/resume-search-alert/{id}
// *******************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';


/**
 * @description SWR: delete resume search alert.
 * @param locale - string, the locale
 * @param id - string, the id of the resume search alert
 * @param successCallback - function, the success callback
 */
export const useSwrDeleteResumeSearchAlert = (locale: string, id: string, successCallback?: () => void) => {
  // SWR mutation
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<object, undefined>({
    url: '/v1/resume-search-alert/',
    urlParams: id,
    locale,
    fetcherConfig: {
      method: 'DELETE',
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
